import { render, staticRenderFns } from "./pagoCertificado.vue?vue&type=template&id=0204f821&scoped=true&"
import script from "./pagoCertificado.vue?vue&type=script&lang=js&"
export * from "./pagoCertificado.vue?vue&type=script&lang=js&"
import style0 from "./pagoCertificado.vue?vue&type=style&index=0&id=0204f821&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0204f821",
  null
  
)

export default component.exports